import { render, staticRenderFns } from "./CategoryTree.vue?vue&type=template&id=b8a1410c&scoped=true"
import script from "./CategoryTree.vue?vue&type=script&lang=js"
export * from "./CategoryTree.vue?vue&type=script&lang=js"
import style0 from "./CategoryTree.vue?vue&type=style&index=0&id=b8a1410c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a1410c",
  null
  
)

export default component.exports